export const dashboard = '/dashboard'
export const dashboardSearchResults = `${dashboard}/results`

export enum SearchResultTab {
  allResults = 'all-results',
  databaseVehicles = 'database-vehicles',
  genericVehicles = 'generic-vehicles',
  accounts = 'accounts',
  invoice = 'invoice',
  parts = 'parts',
  quotations = 'quotations',
  workorders = 'workorders',
  orders = 'orders'
}
